import type { BoosterPriceOfferDto } from "../api/dto/cumulative_boosters.dto.js";
import { CumulativeBoosterID } from "./cumulative_booster_id.js";

export interface PassiveBoosterStubConfig
{
  id: CumulativeBoosterID.Dynamite;
  initial_count: number;
  /** Bought for coins locally: the backend has no price offer for this booster yet. */
  price_offer?: BoosterPriceOfferDto;
}

/** Temporary client-only data. Remove after passive boosters are provided by the backend. */
export const PASSIVE_BOOSTER_STUB_CONFIGS: readonly PassiveBoosterStubConfig[] = [
  {
    id: CumulativeBoosterID.Dynamite,
    initial_count: 3,
  },
];

export function getPassiveBoosterStubConfig( id: CumulativeBoosterID ): PassiveBoosterStubConfig | null
{
  return PASSIVE_BOOSTER_STUB_CONFIGS.find( config => config.id === id ) ?? null;
}
